<template>
  <li class="base__item favorites-base-item">
    <div class="favorites-base__title">
      <svg
        v-if="folder.folders || folder.documents"
        class="favorites-base-item__open-folder" 
        :class="{ _opened: baseOpened }"
        width="14"
        height="14"
        @click="toggleBase"
      >
        <use xlink:href="#chevron" />
      </svg>

      <span class="classifiers__base base">
        {{ folder.name }}
      </span>
    </div>

    <ul v-if="baseOpened && (folder.folders || folder.documents)" class="favorites-base__list">
      <div v-if="folder.documents" class="favorites-home__list favorites">
        <home-favorites-documents
          :documents="folder.documents"
          :currentSectionIsPrivate="currentSectionIsPrivate"
        />
      </div>

      <home-favorites-folders
        v-for="folder in folder.folders"
        :folder="folder"
        :currentSectionIsPrivate="currentSectionIsPrivate"
      />
    </ul>
  </li>
</template>

<script>
  import HomeFavoritesDocuments from './HomeFavoritesDocuments';

export default {
  name: 'HomeFavoritesFolders',

  components: {
    HomeFavoritesDocuments
  },


  props: {
    folder: {
      type: Object,
      required: true
    },
    currentSectionIsPrivate: {
      type: Boolean,
      required: true
    }
  },

  data: () => ({
    baseOpened: false
  }),

  methods: {
    async toggleBase() {
      this.baseOpened = !this.baseOpened;
    }
  }
};
</script>
